import { pgEnum } from 'drizzle-orm/pg-core';

/**
 * @summary
 * <blockquote>Helper function to create a pgEnum from an object of constant values</blockquote>
 * 
 * @param name The name of the enum in the database
 * @param enumObj An object containing the enum values as constants
 * @param name The name of the enum in the database
 * @param enumObj An object containing the enum values as constants
 * @returns A pgEnum that can be used in drizzle table definitions
 * 
 * @example
 * ```typescript
 * const STATUS = {
 *   PENDING: 'pending',
 *   COMPLETED: 'completed'
 * } as const;
 * 
 * const statusEnum = pgEnumFromObject('status', STATUS);
 * 
 * // For nested objects like PRODUCTS, it will use the 'code' property:
 * const PRODUCTS = {
 *   PRODUCT_A: { code: 'product-a', name: 'Product A' }
 * } as const;
 * const productEnum = pgEnumFromObject('product', PRODUCTS);
 * ```
 */
/**
 * @internal
 */
export function pgEnumFromObject<
  T extends { [key: string]: string } | { [key: string]: { code: string } }
>(
  name: string,
  enumObj: T
): ReturnType<typeof pgEnum> {
  const values = Object.values(enumObj).map(value => 
    typeof value === 'string' ? value : value.code
  ) as [string, ...string[]];
  
  return pgEnum(name, values);
}
